/**
 * Field-run piping has no shop fabrication.
 * Shop = "Field Run" is excluded from fab credit and overall fab progress.
 * Shop = "Site" means fabricated on site and stays in fabrication.
 */

export const FIELD_RUN_SHOP = 'field run';

export function isFieldRunShop(shop) {
  return String(shop || '').trim().toLowerCase() === FIELD_RUN_SHOP;
}
